const messages = [
  "Yalnız çalışmak bitti: odaya katıl, birlikte çalış.",
  "Planını yap, arkadaşlarınla aynı anda çalış.",
  "Şu an canlı odalarda öğrenciler birlikte çalışıyor.",
  "Serini koru, ilerlemeni Akış'ta paylaş.",
  "Çalışma arkadaşını bul, kendi ritmini Keşfet'te gör.",
  "TYT ve AYT maratonu beraber kolay.",
  "Aynı masa, farklı şehirler: canlı çalışma odaları.",
  "Puanını, rozetini, serini duvarında göster.",
  "Hiç gün boş geçmesin: günlük planın hazır.",
  "DersKaynağı: birlikte çalışan öğrencilerin yeri."
] as const

let currentIndex = 0

export function getNextMessage(): string {
  currentIndex = (currentIndex + 1) % messages.length
  return messages[currentIndex]
}

export function getPreviousMessage(): string {
  currentIndex = (currentIndex + messages.length) % messages.length
  return messages[currentIndex]
}

export function getCurrentMessage(): string {
  return messages[currentIndex]
}

export function getRandomMessage(): string {
  const randomIndex = Math.floor(Math.random() * messages.length)
  currentIndex = randomIndex
  return messages[randomIndex]
}

export function resetToMain(): void {
  currentIndex = 0
}

export function getAllMessages(): readonly string[] {
  return messages
}
